<template>
    <div class="need-you-help">
        <div class="support-link">
            <support-icon/>
            <span>0808 164 3773</span>
        </div>
    </div>
</template>

<script>
    import SupportIcon from "@/old/svgIcons/supportIcon";

    export default {
        name: "NeedYouHelp",
        components: {SupportIcon}
    }
</script>

<style lang="scss" scoped>
    @import "../scss/variables";

    .need-you-help {
        display: flex;
        justify-content: space-between;
        margin-left: -36px;
        padding: 24px 36px 0;
        box-sizing: border-box;
        width: calc(100% + 72px);
        border-top: solid 1px rgba(255, 255, 255, .1);

        .support-link {
            display: flex;
            align-items: center;

            img, svg {
                height: 16px;
                margin-right: 6px;
                stroke: var(--accent-color);
            }

            span {
                font-size: $m-font-size;
                color: $text-color;
            }
        }
    }
</style>
